<ng-container *transloco="let t;">
<div class="media align-items-center">
    <ng-template #reminderTooltipTpl let-item="item">
        <div class="reminder-tooltip-content">
            <div class="reminder-tooltip-item" *ngFor="let reminder of getReminders(item); let i = index; let last = last">
                <h6 class="text-white mt-0 mb-25">{{ t('Reminder tooltip heading (Documents Section) - Reminder index', { index: i + 1 }) }}</h6>
                <ul>
                    <li><span class="reminder-tooltip-label">{{ t('Reminder tooltip label (Documents Section) - Email reminder for') }}:</span> {{ getReminderUsersText(reminder) }}</li>
                    <li><span class="reminder-tooltip-label">{{ t('Reminder tooltip label (Documents Section) - Message') }}:</span> {{ getReminderMessageText(reminder) }}</li>
                    <li><span class="reminder-tooltip-label">{{ t('Reminder tooltip label (Documents Section) - Reminder date') }}:</span> {{ getReminderDateText(reminder) }}</li>
                </ul>
                <div *ngIf="!last" class="reminder-tooltip-divider"></div>
            </div>
        </div>
    </ng-template>
    <div class="avatar rounded" [ngClass]="dataItem['status'] | documentStatusHelper: 'bg-light'">
        <div class="avatar-content"
        placement="top"
        container="body"
        [autoClose]="true"
        triggers="hover"
        [ngbTooltip]="documentFormat | titlecase">

        @if (dataItem && dataItem['is_uploaded'] === 1) {
            @if (dataItem['file_ext']?.toLowerCase() === 'pdf') {
            <!-- PDF ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.5">
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"/>
                <path d="M17 18h2"/>
                <path d="M20 15h-3v6"/>
                <path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"/>
            </svg>
            }

            @else if (['doc', 'docx'].includes(dataItem['file_ext']?.toLowerCase())) {
            <!-- WORD ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.5">
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M2 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"/>
                <path d="M17 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"/>
                <path d="M9.5 15a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z"/>
                <path d="M19.5 15l3 6"/>
                <path d="M19.5 21l3 -6"/>
            </svg>
            }

            @else if (['xls', 'xlsx'].includes(dataItem['file_ext']?.toLowerCase())) {
            <!-- EXCEL ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.5">
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M4 15l4 6"/>
                <path d="M4 21l4 -6"/>
                <path d="M17 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"/>
                <path d="M11 15v6h3"/>
            </svg>
            }

            @else if (['jpg', 'jpeg', 'png'].includes(dataItem['file_ext']?.toLowerCase())) {
            <!-- IMAGE ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <path d="M21 15l-5-5L5 21"/>
            </svg>
            }

            @else {
            <!-- DEFAULT ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.5">
                <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                <path d="M9 15h6"/>
                <path d="M9 18h4"/>
            </svg>
            }
        }

        @else if (dataItem && dataItem['type'] === documentTypeEnum.TEMPLATEDOCUMENT) {
            <!-- TEMPLATE ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.25">
            <path d="M4 15h16"/>
            <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"/>
            <path d="M4 20h12"/>
            </svg>
        }

        @else {
            <!-- SIGNATURE ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                width="20" height="20" stroke-width="1.5">
            <path d="M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3
                    c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3
                    c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2
                    c.517 0 1.517 .667 3 2"/>
            </svg>
        }
        </div>
    </div>
    <div class="media-body ms-1 text-truncate">
        <a href="javascript:void(0);" class="fw-bold text-dark mb-0 document-title-link">
            <span class="document-title-text">
                {{ dataItem && dataItem['visible_name'] ? dataItem['visible_name'] : dataItem['name'] }}
            </span>
            <span
                *ngIf="hasReminder(dataItem)"
                class="reminder-icon-wrapper"
                [ngClass]="{ 'is-expired': dataItem['is_reminders_expire'] }"
                placement="auto"
                container="body"
                [autoClose]="true"
                triggers="hover"
                tooltipClass="reminder-tooltip"
                [ngbTooltip]="reminderTooltipTpl"
                [tooltipContext]="{ item: dataItem }"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="reminder-icon" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75">
                    <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
                    <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
                </svg>
            </span>
        </a>
        <small placement="top" [autoClose]="true" container="body" triggers="hover" ngbTooltip="Type"> {{ documentType }}</small>
    </div>
</div>
</ng-container>
